import React from 'react'

function toString(value) {
  if (typeof value === 'string') return value
  if (value === null || value === undefined) return ''
  return value.toString ? value.toString() : ''
}

const Default = function ({ value }) {
  const svalue = toString(value)
  return <span>{svalue}</span>
}

export default Default
